module.exports = __webpack_public_path__ + "img/53ea397.jpg";